<template>
    <div ref="formWidgetRef" class="widget-input-date">
        <div class="widget-input-date-item">
            <label v-if="widgetRef.instanceProperties.label" class="field-label"
                :class="{ 'pointer-event-none': mode == 'edit' }" :for="widgetRef.instanceProperties.id">{{
                    widgetRef.instanceProperties.label }}
                <span v-if="widgetRef.validationProperties.required || RulesService.isRequired(widget)">*</span></label>
            <div class="flex flex-row">
                <DateField v-bind="widget.instanceProperties" v-model:modelValue="widgetRef.runtimeProperties.data"
                    :mode="mode" :class="{ 'pointer-events-none': mode == 'edit' }" :disabled="disabled"
                    :readonly="widget.instanceProperties.creationDate"></DateField>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useVModel } from '@vueuse/core';
// import { useLoggerStore } from '../../../stores/loggerStore';
import DateField from '../../lib/DateField.vue';
import RulesService from '../../../services/RulesService';
import _ from 'lodash';

const props = defineProps({
    mode: {
        type: String,
        default: 'view',
    },
    widget: {
        type: Object,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['update:widget']);

// const { logStatuses } = useLoggerStore();

onMounted(() => {
    if (props.widget.instanceProperties.creationDate && props.mode === 'edit') {
        // logStatuses('warn', `Widget ${props.widget.instanceProperties.id} is a creation date field and cannot be edited`);
    }
});

const widgetRef = useVModel(props, 'widget', emit, { passive: true, deep: true });
if (_.isString(widgetRef.value.runtimeProperties.data)) {
    widgetRef.value.runtimeProperties.data = new Date(widgetRef.value.runtimeProperties.data);
}
const formWidgetRef = ref();
</script>

<style lang="postcss" scoped>
.widget-input-date {
    @apply border-0;
}
</style>
